import React from 'react';
const bonuses = [{
  id: 1,
  title: 'MASTERCLASS PRO EDICIÓN EN CAPCUT',
  img: 'https://cdn.magicpatterns.com/uploads/tnsoHxvDkRbyiDSE7Z65RL/pasted-image.png'
}, {
  id: 2,
  title: 'GUÍA PASO A PASO FÓRMULA CREADORA DE CONTENIDO UGC',
  img: 'https://cdn.magicpatterns.com/uploads/eFx4TxXr8GJV6Sjz2YkVjL/pasted-image.png'
}, {
  id: 3,
  title: 'ACCESO A MI COMUNIDAD PRIVADA UGC EN WHATSAPP💘',
  img: 'https://cdn.magicpatterns.com/uploads/u99LPVskW27MrWr6AzKmMP/pasted-image.png'
}, {
  id: 4,
  title: 'MIS PLANTILLAS Y RECURSOS EDITABLES',
  img: 'https://cdn.magicpatterns.com/uploads/3jcGT5YUZDacaSdycHPzGT/pasted-image.png'
}, {
  id: 5,
  title: 'CERTIFICADO OFICIAL DE CREADORA UGC',
  img: 'https://cdn.magicpatterns.com/uploads/9Y4CDz1WeZhwYcPVji1pia/pasted-image.png'
}, {
  id: 6,
  title: 'CÓMO SER EMBAJADORA DE VIAJES IGUAL QUE YO',
  img: 'https://cdn.magicpatterns.com/uploads/hLJbaSgrKBzaThN7bhpsvy/pasted-image.png'
}];
export function BonusSection() {
  return <section className="px-6 py-16 flex flex-col items-center text-center max-w-7xl mx-auto" data-id="element-18">
      <h2 className="font-serif font-bold text-3xl md:text-5xl text-brand-navy mb-10 leading-tight uppercase" data-id="element-19">
        ACCEDÉ AHORA Y LLEVATE <br data-id="element-20" /> 6 BONUS DE REGALO 💘
      </h2>

      <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto px-4" data-id="element-21">
        {bonuses.map(bonus => <div key={bonus.id} className="bg-white rounded-2xl border border-black/10 p-8 flex flex-col items-center shadow-sm" data-id="element-22">
            <span className="text-[#00c853] font-serif font-bold text-3xl mb-4 tracking-tight" data-id="element-23">
              BONUS #{bonus.id}
            </span>

            <h3 className="font-serif font-bold text-brand-navy text-xl mb-8 leading-tight uppercase" data-id="element-24">
              {bonus.title}
            </h3>

            {bonus.img ? <img src={bonus.img} alt={bonus.title} className={`w-full h-auto drop-shadow-2xl ${bonus.id === 3 ? 'max-w-[220px]' : 'max-w-[300px]'}`} data-id="element-25" /> : <div className="w-full aspect-[3/4] bg-brand-lavenderLight/30 rounded-xl border-2 border-dashed border-brand-navy/10 flex items-center justify-center text-brand-navy/30 font-bold text-xs font-serif" data-id="element-26">
                IMAGEN BONUS #{bonus.id}
              </div>}
          </div>)}
      </div>

      <div className="mt-16 space-y-4 px-4" data-id="element-27">
        <p className="font-serif font-bold text-2xl md:text-4xl text-brand-navy leading-tight uppercase" data-id="element-28">
          EN RESÚMEN... <br data-id="element-29" /> HOY TE LLEVÁS TODO ESTO💘
        </p>
        <p className="font-serif text-xl md:text-2xl text-brand-navy leading-tight italic" data-id="element-30">
          ¡Por lo mismo que vas a ganar en tu primera collab paga!😱
        </p>
      </div>
    </section>;
}